// main.js

//import { MainNavigation } from './components/navigation.js';
import { slider } from './components/slider.js';
import { initLightbox } from './components/lightbox.js';
import {Fancybox} from "@fancyapps/ui";
import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", () => {
    // --- Navigation-Logik ---
    const burgerBtn = document.getElementById('burgerButton');
    const nav = document.getElementById('mainNav');

    function openNav() {
        if (!nav) return;
        burgerBtn?.setAttribute('aria-expanded', 'true');
        nav.classList.remove('hidden');
    }

    function closeNav() {
        if (!nav) return;
        burgerBtn?.setAttribute('aria-expanded', 'false');
        nav.classList.add('hidden');
        // Alle geöffneten Submenüs schließen
        closeAllSubmenus();
    }

    function toggleNav() {
        const expanded = burgerBtn?.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            closeNav();
        } else {
            openNav();
        }
    }

    // Mobile Submenüs
    const submenuToggles = document.querySelectorAll('#mainNav [data-submenu-toggle]');

    function closeAllSubmenus(exceptId) {
        document.querySelectorAll('#mainNav ul[id^="submenu-"]').forEach((ul) => {
            if (exceptId && ul.id === exceptId) return;
            ul.classList.add('hidden');
        });
        document.querySelectorAll('#mainNav [data-submenu-toggle][aria-expanded="true"]').forEach((btn) => {
            if (exceptId && btn.getAttribute('aria-controls') === exceptId) return;
            btn.setAttribute('aria-expanded', 'false');
        });
    }

    submenuToggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const id = btn.getAttribute('aria-controls');
            if (!id) return;
            const menu = document.getElementById(id);
            if (!menu) return;
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            if (!expanded) {
                // Schließe andere Submenüs im selben Level
                closeAllSubmenus(id);
            }
            btn.setAttribute('aria-expanded', String(!expanded));
            menu.classList.toggle('hidden', expanded);
        });
    });

    // Burger-Button
    if (burgerBtn && nav) {
        burgerBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleNav();
        });

        // Outside Click schließt Menü auf Mobile
        document.addEventListener('click', (e) => {
            const expanded = burgerBtn.getAttribute('aria-expanded') === 'true';
            if (!expanded) return;
            const target = e.target;
            if (target instanceof Element) {
                if (!nav.contains(target) && target !== burgerBtn && !burgerBtn.contains(target)) {
                    closeNav();
                }
            }
        });

        // Beim Resize: Auf Desktop nicht erzwungen schließen, aber Submenüs zurücksetzen
        window.addEventListener('resize', () => {
            // Tailwind lg = 1024px
            if (window.innerWidth >= 1024) {
                // Desktop: Submenüs über Hover gesteuert; alle mobilen Zustände zurücksetzen
                closeAllSubmenus();
            }
        });
    }

    // --- Slider initialisieren ---
    slider();

    // --- Lightbox initialisieren ---
    initLightbox();

    // --- Scroll-to-Top-Feature ---
    const btnScrollToTop = document.getElementById('btnScrollToTop');
    if (btnScrollToTop) {
        btnScrollToTop.addEventListener('click', e => {
            e.preventDefault();
            scrollToTop(800); // Dauer der Animation in Millisekunden
        });
    }

    /**
     * Ease-Out-Cubic-Funktion
     * t = aktuelle Zeit, b = Startwert, c = Veränderung, d = Dauer
     */
    function easeOutCubic(t, b, c, d) {
        t = t / d - 1;
        return c * (t * t * t + 1) + b;
    }

    /**
     * Animiert das Scrollen zum Seitenanfang
     * @param {number} duration Dauer in Millisekunden
     */
    function scrollToTop(duration) {
        const start = window.pageYOffset;
        const change = -start;
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const val = easeOutCubic(elapsed, start, change, duration);
            window.scrollTo(0, val);
            if (elapsed < duration) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }

    // --- Fancybox Initialisierung für GridGallery ---
    Fancybox.bind('[data-fancybox^="gridgallery"]', {
        Thumbs: false,
        Toolbar: {
            display: [
                { id: "counter", position: "center" },
                "close"
            ]
        },
        animated: true,
        dragToClose: true,
        groupAll: true,
        closeButton: "top",
        Carousel: {
            Dots: true,
            Navigation: true
        }
    });

    // --- Splide Gallery Modal ---
    document.querySelectorAll('[id^="gallery-modal-"]').forEach(function(modal) {
        const uid = modal.id.replace('gallery-modal-', '');
        const splideId = 'splide-gallery-' + uid;
        let splideInstance = null;

        // Modal für Tastaturfokus erreichbar machen
        modal.setAttribute('tabindex', '-1');

        function closeModal() {
            modal.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        }

        // Initialisiere Splide erst beim ersten Öffnen
        function openModal(index) {
            modal.classList.remove('hidden');
            if (!splideInstance) {
                splideInstance = new Splide('#' + splideId, {
                    type: 'slide',
                    start: index,
                    pagination: true,
                    arrows: true,
                    keyboard: 'global',
                    heightRatio: 0.8,
                });
                splideInstance.mount();
            } else {
                splideInstance.go(index);
            }
            document.body.classList.add('overflow-hidden');
            // Fokus auf Modal für ESC
            setTimeout(() => { modal.focus(); }, 0);
        }

        // Klick auf Hintergrund schließt Modal (aber nicht, wenn auf den Slider oder das X geklickt wird)
        modal.addEventListener('mousedown', function(e) {
            // Nur schließen, wenn wirklich auf das Modal (Hintergrund), NICHT auf ein Kindelement (wie das X oder den Slider) geklickt wurde
            if (e.target === modal) {
                closeModal();
            }
        }, false);
        // Schließen-Button
        const closeBtn = modal.querySelector('.close-gallery-modal');
        if (closeBtn) {
            closeBtn.addEventListener('mousedown', function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
            }, false);
        }
        // ESC schließt Modal
        modal.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeModal();
            }
        });
        // Klick auf Bild öffnet Modal
        document.querySelectorAll('.open-gallery-modal').forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                if (link.closest('.ce-gridgallery').querySelector('#' + modal.id)) {
                    openModal(Number(link.dataset.index));
                }
            });
        });
    });
});
